import AuthenticatingPage from "./AuthenticatingPage";
export default AuthenticatingPage;
